import React from 'react'
import cooking from '../../images/cooking.jpg'
import { Article, Card } from '../common/Layout'
import { Link } from 'react-router-dom'
import { rootRoute } from '../../routes/routes'

const style = {
  img: {
    width: '100%'
  }
}
const Maintenance = () => (
  <Article>
    <Card>
      <div className="row center-xs middle-xs">
        <div className="col-xs-12 col-sm-6">
          <img
            style={style.img}
            src={cooking}
            alt="503 Page Under Maintenance"
          />
        </div>
        <div className="col-xs-12 col-sm-6 first-xs last-sm">
          <h1 className="title">The page you were looking for is cooking.</h1>
          <p>
            The server is currently under maintenance. Please try again later!
          </p>
          <Link to={rootRoute.path}>
            <button className="primary">Go home to order</button>
          </Link>
        </div>
      </div>
    </Card>
  </Article>
)

export default Maintenance
